import { defineMessages } from 'react-intl';

export const scope = 'app.containers.Product';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Product',
  },
  marketForecast: {
    id: `${scope}.marketForecast`,
    defaultMessage: 'FIA Product Return with S&amp;P 500<sup>&reg;</sup> Price Index from illustration<sup>1</sup>',
  },
  participationRate: {
    id: `${scope}.participationRate`,
    defaultMessage: 'Participation Rate',
  },
  annualSpread: {
    id: `${scope}.annualSpread`,
    defaultMessage: 'Annual Spread',
  },
  calculate: {
    id: `${scope}.calculate`,
    defaultMessage: 'Calculate',
  },
  reset: {
    id: `${scope}.reset`,
    defaultMessage: 'Reset Values',
  },
  percentageSymbol: {
    id: `${scope}.percentageSymbol`,
    defaultMessage: '%',
  },
  historicalAverageAnnual: {
    id: `${scope}.historicalAverageAnnual`,
    defaultMessage: 'Historical Average Annual S&amp;P 500<sup>&reg;</sup> Price Return Index Performance:<sup>2</sup>',
  },
  neededAnnual: {
    id: `${scope}.neededAnnual`,
    defaultMessage: 'Annual S&amp;P 500<sup>&reg;</sup> Price Return Index Performance Necessary to Achieve Illustrated Rate Above',
  },
  disclaimerOne: {
    id: `${scope}.disclaimerOne`,
    defaultMessage: '<sup>1</sup> Reflects level assumed annual return.',
  },
  disclaimerTwo: {
    id: `${scope}.disclaimerTwo`,
    defaultMessage: '<sup>2</sup> Source: Yahoo Finance. Average Annual Return period for S&amp;P 500<sup>&reg;</sup> Price Index: 10 years from 12/31/2009 to 12/31/2019, 20 years from 12/31/1999 to 12/31/2019, 30 years from 12/31/1989 to 12/31/2019.                           ',
  },
});